import { query, request } from 'src/utils/request';

const urls = {
  userInfo: '/api/zlbuser/user/info',
  modifyUserInfo: '/api/zlbuser/user/modify',
  captcha: '/api/user/loginCaptcha',
  mobileCode: '/api/user/send/mobile/code',
  prevCheck: '/api/user/check/mobile/code',
  modifyMobile: '/api/user/new/mobile',
  unbindRegister: '/api/zlbuser/unbind/register',
  changePassword: '/api/zlbuser/change/password',
};
export function getUserInfo(params) {
  return request(urls.userInfo, { method: 'GET', params });
}

export function modifyUserInfo(data) {
  return request(urls.modifyUserInfo, { method: 'POST', data });
}

//
export async function getCaptcha(params) {
  return request(urls.captcha, { method: 'GET', params });
}

//
export async function getMobileCode(data) {
  return request(urls.mobileCode, {
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded', // hearder 很重要，Content-Type 要写对
    // },
    method: 'POST',
    data,
  });
}

export async function prevCheck(data) {
  return request(urls.prevCheck, { method: 'POST', data });
}

export function modifyMobile(data) {
  return request(urls.modifyMobile, { method: 'POST', data });
}

// 解除绑定
export function unbindRegister(data) {
  return query(urls.unbindRegister, { method: 'POST', data });
}

// 修改密码
export function changePassword(data) {
  return query(urls.changePassword, { method: 'POST', data });
}
